import { AddressSuggestion } from './api/models';

/** Formats an address line the way DAWA does: "Smedeholm 3, 1. tv". */
export const toAddressLine = ({ vejnavn, husnr, etage, dør }: AddressSuggestion['data']) => {
    const street = [vejnavn, husnr].filter(Boolean).join(' ');
    const unit = [etage && `${etage}.`, dør].filter(Boolean).join(' ');

    return [street, unit].filter(Boolean).join(', ');
};
